import { lazy } from 'react';
import { AdvancedCobranding } from '../../utilities/cobranding/cobranding';
import { AdvancedCobrandedPage } from '../orchestrator';

export const pages: Array<AdvancedCobrandedPage> = [
  {
    application: 'pollinator',
    cobranding: AdvancedCobranding.DEMO,
    Component: lazy(() => import('../../advanced-cobranding/pollinator/demo/LoginPage')),
    owner: 'iignatov2@atlassian.com',
    slackChannel: 'id-kirby',
    monitoringUrls: [
      // TODO: Kirby to add demo pollinator
      '',
    ],
  },
];
